module.exports = __webpack_public_path__ + "img/silder_02_slogan_01.93a31941.png";